import '@elotech/arc/src/assets/less/compiled/itbicidadao.css';

import React from 'react';

const ThemeRebranding: React.FC = () => null;

export default ThemeRebranding;
